/* eslint-disable indent */
import { LOGIN, LOGOUT } from '../actions/authActions';

const initialAuthState = {
  isAuthenticated: !!localStorage.getItem('X-Auth-Token'),
};

const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isAuthenticated: true,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;
